import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/medconsult_pro/src/app/service-overview/components/ServiceOverviewInteractive.tsx");
